module.exports = __webpack_public_path__ + "static/media/orange_class.e2f1e3ff.PNG";